import type { FaireProductEntity } from "../../entity_types/product";

export const p_kj9mx7jry9: FaireProductEntity = {
  token: "p_kj9mx7jry9",
  type: "product",
  name: "SAINT MALO",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl: "https://cdn.faire.com/fastly/77b0cd1eb85f88766a39da905e3d98ea9a0128875add3542420a161ceff172b8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8fe9a7bfa0ac404217c036abdc77574009b2724570ec3a21626f69150ecd9609.jpeg",
    "https://cdn.faire.com/fastly/1fd7bb5266d3bb8538643fda9421186f57f2b1fe1f83da6bd00e278532d8c414.jpeg",
    "https://cdn.faire.com/fastly/c7cb13b91e994302e1ef9d8964d19fbf58993d9ed1734ebe39fead7c8dc14443.jpeg"
  ],
  priceDollars: 19,
  description: "Memories of cool mornings spent along the white sandy shoreline of Brittany’s emerald coast. Take in in the majestic rocky seashore with briny notes of salt air and driftwood and the faintest whisper of bright citrus and wild herbs. Linger amidst the endless wandering sand banks of Saint-Malo beach.\n\ngrapefruit peel, mint leaves, limoncello, cedarwood, sweet basil\n\nRoen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn. We use lead-free cotton wicks and premium fragrance oils. All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials.\n\n8 ounces (226g), comes in our signature French box.",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:05:07.002Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
